import styled from 'styled-components'

export default styled.div`
  background-color: #aeaeae;
  height: 1px;
  margin: 7px auto 7px;
  width: 100%;
`
